<input
        [(ngModel)]="param"
        (ngModelChange)="doInput()"
        (blur)="doBlur()"
        class="form-control text-end"
        type="text"
        (keyup)="doKeyUp($event)"
        placeholder="0,00"
        mask="separator.{{numberOfDecimals}}" thousandSeparator="."
        tabIndex="{{tabIndex}}"
        inputmode="tel"
        [allowNegativeNumbers]="allowMinusSign"
        [disabled]="readonly"
        value="{{inputValue}}"
        #myInput
/>
